/**
 * Created by vladislav on 3/25/19
 */

const SpecialShapeComponentView = cc.Node.extend({
    ctor: function (component, cellView) {
        this._super();

        this.component = component;
        this.cellView = cellView;

        const size = component.getSize();
        const cellSize = cleverapps.styles.BaseCellView.CELL_SIZE_PX;
        const styles = this.getStyles();

        this.cellView.setAnchorPoint(0.5, 0.5);

        if (this.component.cell.isForEditor || this.component.cell.isForGoal) {
            this.cellView.setContentSize2(styles.goal.width, styles.goal.width);
        } else {
            this.cellView.setContentSize2(cellSize * size.cols, cellSize * size.rows);
            this.cellView.setAlignment(this.calcPositionInTheGrid());
        }
    },

    calcPositionInTheGrid: function () {
        const size = this.component.getSize();

        return BaseCellView.alignInTheGrid(this.component.cell.topLeftX + size.cols / 2 - 0.5, this.component.cell.topLeftY + size.rows / 2 - 0.5);
    },

    scaleViewContent: function () {
        const styles = this.getStyles();
        const cellSize = cleverapps.styles.BaseCellView.CELL_SIZE_PX;
        const size = this.component.getSize();

        const scaleX = styles.goal.width / (size.rows * cellSize);
        const scaleY = styles.goal.height / (size.cols * cellSize);
        this.cellView.getChildren().forEach((child) => {
            child.setScale(Math.min(scaleX, scaleY));
        });
    },

    getStyles: function () {
        return cleverapps.styles.SpecialShapeComponentView;
    }
});

SpecialShapeComponentView.ROTATION_BY_ID = [0, 90, 180, -90];

cleverapps.styles.SpecialShapeComponentView = {
    goal: {
        width: 120,
        height: 120
    }
};